//import arrowUpDown from "../../images/arrowsupdown.png";

import pencil from '../../images/pencil.png';
import plusIcon from '../../images/plus_icon.png';
import xIcon from '../../images/x_icon.png';
import okIcon from '../../images/ok_icon.png';
import search from '../../images/search.png';
import trash from '../../images/trash.svg';
import trophyGold from '../../images/trophy-gold.png';
import trophySilver from '../../images/trophy-silver.png';

export const editar = pencil;
export const cancelar = xIcon;
export const aceptar = okIcon;
export const agregar = plusIcon;
export const buscar = search;
export const borrar = trash;
export const campeon = trophyGold;
export const subCampeon = trophySilver;

export { default as cambioSale } from '../../images/arrowdown.png';
export { default as cambioSaleDisabled } from '../../images/arrowdowngray.png';
export { default as cambioEntra } from '../../images/arrowup.png';
export { default as cambioEntraDisabled } from '../../images/arrowupgray.png';
export { default as gol } from '../../images/pelota.png';
export { default as golDisabled } from '../../images/pelotagray.png';
export { default as tarjetaAmarilla } from '../../images/yellowcard.png';
export { default as tarjetaAmarillaDisabled } from '../../images/yellowcardgray.png';
export { default as tarjetaRoja } from '../../images/redcard.png';
export { default as tarjetaRojaDisabled } from '../../images/redcardgray.png';
